import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Button, getTextTokenPreset, getSpacingToken, getToken, IconName, Stack, ZIndex } from '@optimus-web/core';
import { LocalizedCurrencyValue, LocalizedText, useScope } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { getSelectedTotalAmount } from '../selectors';
import { COLOR_WHITE } from '../../../components';
import { openItemAssignmentDialog } from '../ducks/itemAssignment';
import { deselectAll, getMovableItemsCount, isAnythingSelected } from '../ducks/billItems';

const TopToolbarWrapper = styled.div`
    background-color: ${getToken('backgroundInteractivePrimaryDefault')};
    border-radius: ${getSpacingToken('100')}px;
    padding: ${getSpacingToken('100')}px ${getSpacingToken('200')}px;
    color: ${COLOR_WHITE};
    position: sticky;
    top: 0;
    z-index: ${ZIndex.Normal};
`;

const TotalText = styled.span`
    ${getTextTokenPreset('bodyLargeStrong')};
    color: ${COLOR_WHITE};
`;

export const TopToolbar = () => {
    const dispatch = useDispatch();
    const scope = useScope() ?? '';
    const enterpriseId = useCurrentEnterpriseId();
    const anythingSelected = useCommanderSelector((state) => isAnythingSelected(state, { scope }));
    const movableItemsCount = useCommanderSelector((state) => getMovableItemsCount(state, { scope }));
    const selectedItemsAmount = useCommanderSelector((state) => getSelectedTotalAmount(state, { enterpriseId, scope }));

    const onMoveItems = () => dispatch(openItemAssignmentDialog({ billId: null, scope }));
    const onDeselectAll = () => dispatch(deselectAll(scope));

    if (!anythingSelected) return null;

    return (
        <TopToolbarWrapper data-test-sidebar-element>
            <Stack itemAlignment="center" distribution="space-between">
                <Stack itemAlignment="center" spacing="200">
                    <LocalizedText textKey={TextKey.SelectedItems} substitutes={{ count: movableItemsCount }} />
                    <TotalText>
                        <LocalizedText textKey={TextKey.Total} />
                        {UnicodeEntity.Colon}
                        {UnicodeEntity.NoBreakSpace}
                        <LocalizedCurrencyValue value={selectedItemsAmount} />
                    </TotalText>
                </Stack>
                <Stack itemAlignment="center" spacing="100">
                    <Button
                        icon={IconName.MovePayment}
                        onClick={onMoveItems}
                        variant="primary"
                        data-move-selected-items
                        type="submit"
                    >
                        <LocalizedText textKey={TextKey.Move} />
                    </Button>
                    <Button icon={IconName.MinusSimple} onClick={onDeselectAll} variant="primary" type="submit">
                        <LocalizedText textKey={TextKey.DeselectAll} />
                    </Button>
                </Stack>
            </Stack>
        </TopToolbarWrapper>
    );
};
